export default __webpack_public_path__ + "8dbf912a82db04daf0e8d00fcd3fd30e.jpg";